module.exports = __webpack_public_path__ + "ff24c8b40b7523913152dcbc1fe019e8.svg";